export default "__VITE_ASSET__SPu$i8zB__";